import styled from "styled-components"

interface IHeadingProps {
  level: "h1" | "h2"
  children: React.ReactNode | string
}
const BaseHeading = styled.h1`
  font-weight: 700;
  margin: 0;
  text-align: center;
`
const StyledH1 = styled(BaseHeading)`
  font-size: 2rem;
  font-size: clamp(2rem, 1.8rem + 1vw, 3rem);
  line-height: 120%;
  letter-spacing: 0.04em;
`
const StyledH2 = styled(BaseHeading)`
  font-size: 1.1rem;
  font-size: clamp(1.1rem, 0.97rem + 0.65vw, 1.75rem);
  line-height: 150%;
  letter-spacing: 0.05em;
`

const Heading = (props: IHeadingProps) => {
  const { level, children } = props
  if (level === "h1") {
    return <StyledH1>{children}</StyledH1>
  }
  return <StyledH2 as="h2">{children}</StyledH2>
}

export { Heading }
